import React from 'react';
import { useMediaQuery } from 'usehooks-ts';
import styles from './PlanFindADealer.module.scss';

const FindADealer = ({ data }) => {
  const isTablet = useMediaQuery('(max-width: 834px)');
  const isMobile = useMediaQuery('(max-width: 480px)');

  const getImageUrl = (imageField) => {
    if (!imageField?.fields) return '';

    const getImageUrlFromField = (field) => {
      if (!field?.value?.src) return '';
      return field.value.src;
    };

    if (isMobile) {
      return (
        getImageUrlFromField(imageField.fields.mobileImage) ||
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    if (isTablet) {
      return (
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    return getImageUrlFromField(imageField.fields.desktopImage) || '';
  };

  const imageUrl = getImageUrl(data?.image);
  const textContent = data?.text || '';
  const buttonText = data?.buttonText || '';
  const buttonUrl = data?.buttonUrl || '';
  const isComingSoon = data?.isComingSoon || false;

  return (
    <section className={styles.container} data-aos="fade-up">
      <div className={styles.wrapper}>
        {imageUrl && (
          <img src={imageUrl} alt="Hero background" className={styles.backgroundImage} />
        )}
        <div className={styles.contentContainer}>
          {textContent && (
            <div className={styles.containerText}>
              <div dangerouslySetInnerHTML={{ __html: textContent }} />
            </div>
          )}
          {(buttonText || isComingSoon) && (
            <div className={styles.containerLink}>
              {isComingSoon ? (
                <button className={styles.comingSoon}>Coming soon</button>
              ) : (
                buttonText &&
                buttonUrl && (
                  <a className={styles.pcButton} href={buttonUrl}>
                    {buttonText}
                  </a>
                )
              )}
            </div>
          )}
        </div>
      </div>
      {isComingSoon ? (
        <button className={styles.comingSoonMobile}>Coming soon</button>
      ) : (
        buttonText &&
        buttonUrl && (
          <a className={styles.laptopButton} href={buttonUrl}>
            {buttonText}
          </a>
        )
      )}
    </section>
  );
};

export default FindADealer;
